// extracted by mini-css-extract-plugin
module.exports = {"totalDeaths":"OtherCases_totalDeaths__20JHV","totalDeathsWrapper":"OtherCases_totalDeathsWrapper__30wiA"};